import { HOT_TAGS, NEWS, HOT_WORDS } from '@/mocks/gossip';

export default function Hero() {
  return (
    <section className="relative overflow-hidden border-b border-background-200/70 bg-background-50">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 px-4 py-10 md:px-6 md:py-14 lg:grid-cols-[1.15fr_0.85fr]">
        {/* 左：文案优先 */}
        <div className="flex flex-col justify-center">
          <div className="mb-4 inline-flex items-center gap-2 self-start rounded-full bg-accent-100 px-3 py-1.5 text-xs font-medium text-accent-900">
            <i className="ri-flashlight-fill text-accent-600" aria-hidden="true" />
            婚内出轨娱乐圈热点 · 一手吃瓜持续更新
          </div>
          <h1 className="text-3xl leading-tight tracking-wide text-foreground-950 md:text-[2.6rem]">
            把<b className="text-primary-600">婚内出轨</b>的
            <br />
            实锤与争议，做成看得懂的瓜料
          </h1>
          <p className="mt-4 max-w-xl text-sm leading-7 text-foreground-700 md:text-base">
            持续关注<b>婚内出轨明星</b>、<b>婚内出轨男星</b>与<b>婚内出轨女星</b>的真实曝光，
            按人物与时间线把<b>婚内出轨实锤</b>和<b>婚内出轨事件</b>逐条归档，
            一句话讲清前因后果，随时查找人物、争议与后续动态。
          </p>

          <div className="mt-6 flex flex-wrap gap-2">
            {HOT_WORDS.map((w) => (
              <button
                key={w}
                type="button"
                className="cursor-pointer whitespace-nowrap rounded-full border border-background-300/70 bg-background-50 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:bg-primary-100 hover:text-primary-800"
              >
                <i className="ri-fire-line mr-1 text-primary-500" aria-hidden="true" />
                {w}
              </button>
            ))}
          </div>

          <div className="mt-8 grid grid-cols-3 gap-3">
            {[
              { num: '12+', label: '今日实锤更新' },
              { num: '40+', label: '人物争议归档' },
              { num: '7×24', label: '吃瓜热线' },
            ].map((s) => (
              <div key={s.label} className="rounded-lg border border-background-200/70 bg-background-100 p-3 text-center">
                <div className="text-xl font-bold text-primary-600 md:text-2xl">{s.num}</div>
                <div className="mt-1 text-xs text-foreground-600">{s.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* 右：视觉陪衬 - 分区感强的看板 */}
        <div className="flex flex-col gap-4">
          <div className="rounded-xl border border-background-200/70 bg-gradient-to-br from-background-50 to-secondary-100 p-5">
            <div className="flex items-center justify-between">
              <h2 className="flex items-center gap-2 text-sm font-bold tracking-wide text-foreground-900">
                <i className="ri-archive-drawer-line text-accent-600" aria-hidden="true" />
                今日热搜瓜讯
              </h2>
              <span className="text-xs text-foreground-500">自动排序中</span>
            </div>
            <div className="mt-3 space-y-2">
              {NEWS.slice(0, 3).map((n, i) => (
                <button
                  key={n.id}
                  type="button"
                  className="group flex w-full cursor-pointer items-center gap-3 rounded-lg bg-background-50/80 p-3 text-left transition-colors hover:bg-background-50"
                >
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-primary-500 text-xs font-bold text-background-50">
                    {i + 1}
                  </span>
                  <span className="line-clamp-2 flex-1 text-xs leading-5 text-foreground-800 group-hover:text-primary-700">
                    {n.title}
                  </span>
                  <i className="ri-arrow-right-line text-sm text-foreground-400" aria-hidden="true" />
                </button>
              ))}
            </div>
            <div className="mt-3 flex flex-wrap gap-1.5">
              {HOT_TAGS.slice(0, 6).map((t) => (
                <span
                  key={t.name}
                  className="whitespace-nowrap rounded-full bg-accent-100 px-2 py-0.5 text-[11px] text-accent-800"
                >
                  #{t.name}
                </span>
              ))}
            </div>
          </div>

          {/* 免责与信任提示 */}
          <div className="rounded-xl border border-accent-200 bg-accent-50/70 p-4">
            <div className="flex items-start gap-3">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-shield-check-line text-lg" aria-hidden="true" />
              </span>
              <div>
                <h3 className="text-sm font-bold text-accent-900">理性吃瓜 · 拒绝误伤</h3>
                <p className="mt-1 text-xs leading-5 text-accent-800/80">
                  本站仅做公开信息的整理归档，标注“实锤 / 疑云 / 暗糖”均不代表最终定性，
                  任何人未定论前请理性看待、不传播未经证实内容。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}